<template>
  <div :id="position + '-wrapper'" class="fab-wrapper" v-click-outside="away"
       :style="[ pos, {zIndex: zIndex}, {position: positionType} ]">
    <div :id="position + '-action'" class="actions-container" :style="listPos">
      <transition name="fab-actions-appear"
                  :enter-active-class="transitionEnter"
                  :leave-active-class="transitionLeave"
      >
        <ul v-show="toggle" class="fab-list">
          <template v-for="action in actions">
            <transition
              :key="action.name"
              enter-active-class="animated quick zoomIn"
              leave-active-class="animated quick zoomOut"
              v-on:after-enter="afterActionsTransitionEnter"
            >
              <li v-if="toggle" :style="{ 'background-color': action.color || bgColor }"
                  :id="`fab-tooltip-${action.name}`"
                  @click="toParent(action.name)" class="pointer"
                  ref="actions">
                <font-awesome-icon
                  :class="[ actionIconSize ,'material-icons']"
                  :icon="action.icon"
                />
                <b-tooltip ref="tooltip" :show="showTooltips" triggers="" placement="left" :target="`fab-tooltip-${action.name}`">
                  {{ action.tooltip }}
                </b-tooltip>
              </li>
            </transition>
          </template>
        </ul>
      </transition>
    </div>
    <template v-if="rippleShow">
      <template v-if="mainTooltip">
        <div
          @click="mainClicked"
          class="fab-main pointer "
          :style="{ 'background-color': bgColor, 'padding': paddingAmount }"
        >
          <icool-icon
            :class="[ mainIconSize , { rotate: toggle && allowRotation } ,'material-icons main']"
            :icon="mainIcon" />

          <font-awesome-icon
            :class="[ mainIconSize , { rotate: toggle && allowRotation } ,'material-icons close']"
            icon="plus"
          />
        </div>
      </template>
      <template v-else>
        <div
          @click="mainClicked"
          class="fab-main pointer"
          :style="{ 'background-color': bgColor, 'padding': paddingAmount }"
        >
          <icool-icon
            :class="[ mainIconSize , { rotate: toggle && allowRotation }, 'material-icons main']"
            :icon="mainIcon"
          />
          <font-awesome-icon
            :class="[ mainIconSize , { rotate: toggle && allowRotation }, 'material-icons close']"
            icon="plus"
          />
        </div>
      </template>
    </template>
    <template v-else>
      <template v-if="mainTooltip">
        <div
          class="fab-main pointer"
          :style="{ 'background-color': bgColor, 'padding': paddingAmount }"
        >
          <icool-icon
            class="material-icons md-36 main" :class="{ rotate: toggle && allowRotation }"
            :icon="mainIcon"
          />
          <font-awesome-icon
            class="material-icons md-36 close" :class="{ rotate: toggle && allowRotation }"
            icon="plus"
          />
        </div>
      </template>
      <template v-else>
        <div
          class="fab-main pointer"
          :style="{ 'background-color': bgColor, 'padding': paddingAmount }"
        >
          <icool-icon
            class="material-icons md-36 main" :class="{ rotate: toggle && allowRotation }"
            :icon="mainIcon"
          />
          <font-awesome-icon
            class="material-icons md-36 close" :class="{ rotate: toggle && allowRotation }"
            icon="plus"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      toggle: this.startOpened,
      pos: {},
      tooltipPosition: 'left',
      showTooltips: false,
    };
  },
  props: {
    bgColor: {
      default: '#333333',
    },
    position: {
      default: 'bottom-right',
    },
    positionType: {
      default: 'fixed',
    },
    zIndex: {
      default: '999',
    },
    rippleShow: {
      default: true,
    },
    rippleColor: {
      default: 'light',
    },
    mainIcon: {
      default: 'add',
    },
    iconSize: {
      default: 'medium',
    },
    mainTooltip: {
      default: null,
    },
    fixedTooltip: {
      default: false,
    },
    tooltipTimeOutWhenStartOpened: {
      default: 200,
    },
    enableRotation: {
      default: true,
    },
    actions: {
      default: () => [],
    },
    startOpened: {
      default: false,
    },
    toggleWhenAway: {
      default: true,
    },
  },
  computed: {
    actionIconSize() {
      switch (this.iconSize) {
        case 'small':
          return 'xs';
        case 'medium':
          return 'sm';
        case 'large':
          return 'lg';
        default:
          return '2x';
      }
    },
    allowRotation() {
      return this.enableRotation && this.actions && this.actions.length;
    },
    mainIconSize() {
      switch (this.iconSize) {
        case 'small':
          return 'xs';
        case 'medium':
          return 'sm';
        case 'large':
          return 'lg';
        default:
          return '2x';
      }
    },
    paddingAmount() {
      switch (this.iconSize) {
        case 'small':
          return '28px';
        case 'medium':
          return '32px';
        case 'large':
          return '38px';
        default:
          return '32px';
      }
    },
    listPos() {
      if (this.position === 'top-right' || this.position === 'top-left') {
        return {
          top: '-20px',
          paddingTop: '20px',
        };
      }
      return {
        bottom: '-20px',
        paddingBottom: '20px',
      };
    },
    transitionEnter() {
      const { enter } = this.animation;
      return enter;
    },
    transitionLeave() {
      const { leave } = this.animation;
      return leave;
    },
    animation() {
      if (this.position === 'top-right' || this.position === 'top-left') {
        return {
          enter: 'animated quick fadeInDown',
          leave: 'animated quick fadeOutUp',
        };
      } else if (this.position === 'bottom-right' || this.position === 'bottom-left') {
        return {
          enter: 'animated quick fadeInUp',
          leave: 'animated quick fadeOutDown',
        };
      } else {
        return {
          enter: 'animated fadeInUp',
          leave: 'animated fadeOutDown',
        };
      }
    },
  },
  methods: {
    mainClicked() {
      this.toggle = !this.toggle;
      if (!this.toggle) {
        this.showTooltips = false;
      }
    },
    tooltipPos() {
      if (this.position === 'top-right' || this.position === 'bottom-right') {
        this.tooltipPosition = 'left';
      } else {
        this.tooltipPosition = 'right';
      }
    },
    toParent(name) {
      this.$emit('click', name);
      this.toggle = false;
      this.showTooltips = false;
    },
    away() {
      if (this.toggleWhenAway) {
        this.toggle = false;
        this.showTooltips = false;
      }
    },
    setPosition() {
      this.pos = {};
      switch (this.position) {
        case 'bottom-right':
          this.pos.right = '5vw';
          this.pos.bottom = '4vh';
          break;
        case 'bottom-left':
          this.pos.left = '5vw';
          this.pos.bottom = '4vh';
          break;
        case 'top-left':
          this.pos.left = '5vw';
          this.pos.top = '4vh';
          break;
        case 'top-right':
          this.pos.right = '5vw';
          this.pos.top = '4vh';
          break;
        default:
          this.pos.right = '5vw';
          this.pos.bottom = '4vh';
      }
    },
    moveTransition() {
      const wrapper = document.getElementById(`${this.position}-wrapper`);
      const el = document.getElementById(`${this.position}-action`);

      if (this.position === 'top-right' || this.position === 'top-left') {
        wrapper.appendChild(el);
      } else {
        wrapper.insertBefore(el, wrapper.childNodes[0]);
      }
    },
    showTooltip(timeOut = 0) {
      if (this.toggle && this.actions.length && this.fixedTooltip) {
        setTimeout(() => {
          this.showTooltips = true;
        }, timeOut);
      }
    },
    afterActionsTransitionEnter() {
      this.showTooltip();
    },
  },
  watch: {
    position(val) {
      this.setPosition();

      this.$nextTick(() => {
        this.moveTransition();
        this.tooltipPos();
      });
    },
  },
  mounted() {
    this.moveTransition();
  },
  created() {
    this.setPosition();
  },
};
</script>

<style scoped>
  .animated.quick {
    -webkit-animation-duration: .7s !important;
    animation-duration: .7s !important;
  }

  .fab-wrapper {
    z-index: 999;
  }

  .fab-main {
    border-radius: 100px;
    /*width: 65px;*/
    /*height: 65px;*/
    padding: 30px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.20), 0 4px 4px rgba(0, 0, 0, 0.15);
    z-index: 2;
    justify-content: center;
  }

  .fab-main .material-icons {
    color: white;
    -webkit-transition: .4s all;
    -moz-transition: .4s all;
    transition: .4s all;
    margin: 0px auto;
  }

  .fab-main .material-icons.main {
    opacity: 1;
    position: absolute;
  }

  .fab-main .material-icons.close {
    opacity: 0;
    position: absolute;
  }

  .fab-main .material-icons.main.rotate {
    -ms-transform: rotate(315deg); /* IE 9 */
    -webkit-transform: rotate(315deg); /* Chrome, Safari, Opera */
    transform: rotate(315deg);
    opacity: 0;
    -webkit-transition: opacity .3s ease-in, -webkit-transform .4s; /* Safari */
    transition: opacity .3s ease-in, transform .4s;
  }

  .fab-main .material-icons.close.rotate {
    -ms-transform: rotate(315deg); /* IE 9 */
    -webkit-transform: rotate(315deg); /* Chrome, Safari, Opera */
    transform: rotate(315deg);
    opacity: 1;
    -webkit-transition: opacity .3s ease-in, -webkit-transform .4s; /* Safari */
    transition: opacity .3s ease-in, transform .4s;
  }

  .fab-list {
    position: relative;
    z-index: 1;
    margin: 2vh 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .fab-list li {
    /*width: 50px;*/
    /*height: 50px;*/
    padding: 10px;
    margin-top: 2vh;
    display: flex;
    align-items: center;
    border-radius: 100px;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.20), 0 4px 4px rgba(0, 0, 0, 0.15);
  }

  .fab-list li .material-icons {
    color: white;
    margin: 0px auto;
  }

  .pointer {
    cursor: pointer;
  }

  ul {
    list-style-type: none;
    padding: 0 !important;
  }

  .fab-wrapper .actions-container {
    overflow: hidden;
    z-index: 0;
    position: relative;
  }

  /* Rules for sizing the icon. */
  .material-icons.md-18 {
    font-size: 18px;
  }

  .material-icons.md-24 {
    font-size: 24px;
  }

  .material-icons.md-36 {
    font-size: 36px;
  }

  .material-icons.md-48 {
    font-size: 48px;
  }

  /* Rules for using icons as black on a light background. */
  .material-icons.md-dark {
    color: rgba(0, 0, 0, 0.54);
  }

  .material-icons.md-dark.md-inactive {
    color: rgba(0, 0, 0, 0.26);
  }

  /* Rules for using icons as white on a dark background. */
  .material-icons.md-light {
    color: rgba(255, 255, 255, 1);
  }

  .material-icons.md-light.md-inactive {
    color: rgba(255, 255, 255, 0.3);
  }

  @media screen and (max-width: 768px) {
    .fab-list {
      margin: 2vh 0;
    }

    .fab-list li {
      /*width: 40px;*/
      /*height: 40px;*/
      /*padding: .6rem;*/
    }

    .fab-list li i {
      /*font-size: 24px !important;*/
    }

    .fab-main {
      /*width: 55px;*/
      /*height: 55px;*/
      /*padding: 1.5rem;*/
    }

    .fab-main i {
      /*font-size: 34px !important;*/
    }

  }
</style>
